import React, { memo } from 'react';
import { DataGridRowGroup } from "../DataGridRowGroup/DataGridRowGroup.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const DataGridRowGroups = /*#__PURE__*/memo(({
  sortedGroups,
  focusRow,
  rowDecorator,
  columnCount,
  hydratedColumns,
  toggleRow,
  lastColumnFixed,
  rowBody,
  activeRow,
  rowAlternating,
  hasBody,
  contextMenu,
  closeMenu,
  isOverflowing,
  fullyScrolledLeft
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sortedGroups.map((group, index) => /*#__PURE__*/_jsx(DataGridRowGroup, {
      group: group,
      rowAlternating: rowAlternating,
      columnCount: columnCount,
      hydratedColumns: hydratedColumns,
      rowDecorator: rowDecorator,
      isLastGroup: index === sortedGroups.length - 1,
      isFirstGroup: index === 0,
      hasBody: hasBody,
      onRightClick: contextMenu ? focusRow : undefined,
      onRowClick: toggleRow,
      isLastColumnFixed: lastColumnFixed,
      rowBody: rowBody,
      openedRow: activeRow.open,
      focusRow: focusRow,
      contextMenu: contextMenu,
      closeMenu: closeMenu,
      focusedRow: activeRow.focus,
      isOverflowing: isOverflowing,
      fullyScrolledLeft: fullyScrolledLeft
    }, group._id))
  });
});